import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  Text,
  Link,
  Alert,
  AlertIcon,
  Container,
  useToast,
  Card,
  CardBody,
  Heading,
} from '@chakra-ui/react';
import { useSupabaseClient } from '@supabase/auth-helpers-react';
import RotaryLogo from './RotaryLogo';
import ProductName from './ProductName';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const supabase = useSupabaseClient();
  const toast = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`,
      });

      if (error) throw error;

      setSuccess(true);
      toast({
        title: "Reset email sent",
        description: "Please check your email for password reset instructions.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      console.error('Password reset error:', error);
      setError('Error sending reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxW="lg" py={{ base: '12', md: '24' }} px={{ base: '0', sm: '8' }}>
      <Card>
        <CardBody>
          <VStack spacing="6">
            <RotaryLogo width="100px" height="100px" />
            <ProductName />
            <Heading size="lg">Reset Password</Heading>

            {error && (
              <Alert status="error">
                <AlertIcon />
                {error}
              </Alert>
            )}

            {success ? (
              <VStack spacing={4}>
                <Text>Check your email for password reset instructions.</Text>
                <Button onClick={() => navigate('/login')} colorScheme="blue">
                  Return to Login
                </Button>
              </VStack>
            ) : (
              <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                <VStack spacing={4} width="100%">
                  <FormControl isRequired>
                    <FormLabel>Email</FormLabel>
                    <Input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter your email"
                    />
                  </FormControl>

                  <Button
                    type="submit"
                    colorScheme="blue"
                    width="100%"
                    isLoading={loading}
                  >
                    Send Reset Instructions
                  </Button>

                  <Link color="blue.500" onClick={() => navigate('/login')}>
                    Back to Login
                  </Link>
                </VStack>
              </form>
            )}
          </VStack>
        </CardBody>
      </Card>
    </Container>
  );
};

export default ForgotPassword;
